/**************
 Cart
 ***************/

// open cart
async function openCart(addedProduct, groupId = null) {
    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }

    // hide all sections
    document.querySelector("#miniCartHeader").classList.remove("active");
    document.querySelector("#miniCartBody").classList.remove("active");
    document.querySelector("#miniCartButton").classList.remove("active");
    document.querySelector("#miniCartContinue").classList.remove("active");

    // start loading on the cart
    document.querySelector("#miniCartContent").classList.add("loading");

    // fetch cart
    cart = await getCart();

    //add drop animation class on cart
    document.querySelector('#miniCartContent').classList.add('active');

    // stop loading on the cart
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerCart')?.setAttribute("data-count", cart.item_count);
    document.querySelector("#miniCartButton").textContent = `View Cart (${cart.item_count})`;

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartButton").classList.add("active");
    document.querySelector("#miniCartContinue").classList.add("active");

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // if a group id is present, show items connected with the bundle
    if (groupId) {
        cart.items.forEach(function (item) {
            if (item?.properties?._group_id === groupId) {
                // insert item
                document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `${cartItem(item, true)}`);
            }
        })
    } else {
        // find recently added
        const recentlyAdded = cart.items.find(item => item.id === addedProduct.id);
        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `${cartItem(recentlyAdded)}`);
    }
}

// variant HTML
function variantHTML(item) {
    let HTML = "";

    // add any options to variant section on cart item
    for (let option in item.options_with_values) {
        // skip default
        if (item.options_with_values[option].value === "Default Title") continue;

        HTML += `<div class="miniCartBodyItemVariantItem">${item.options_with_values[option].name}: ${item.options_with_values[option].value}</div>`
    }

    // add any properties to variant section on cart item
    for (let key in item.properties) {
        // skip properties that start with _
        if (key.startsWith("_")) continue;

        // add property to HTML
        HTML += `<div class="miniCartBodyItemVariantItem">${key}: ${item.properties[key]}</div>`
    }

    return HTML;
}

// HTML item
function cartItem(item, groupItem = false) {
    return `
        <div class="miniCartBodyItem ${groupItem ? "miniCartBodyItemGroup" : ""}">
            <img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.product_title}">
            <div class="miniCartBodyItemFlex">
                <div class="miniCartBodyItemTitle">${item.product_title}</div>
                <div class="miniCartBodyItemVariant">${variantHTML(item)}</div>
            </div>
            <div class="miniCartBodyItemQuantity">Qty: ${item.quantity}</div>
        </div>
    `
}

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector('#miniCartContent').classList.remove('active');
    // give time for cart to rise off screen
    setTimeout(() => {
        document.querySelector("#miniCart").close();
    }, 800)
}

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));